import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWave = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			y: 2.5,
			width: 1.6,
			height: 6,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2,
			width: 1.6,
			height: 7,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.4,
			y: .4,
			width: .8,
			height: 10.2,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 2.5,
			width: 1.6,
			height: 6,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgWave);
export { ForwardRef as ReactComponent };
